import { render, staticRenderFns } from "./FirstCur.vue?vue&type=template&id=1be85de3&scoped=true&"
import script from "./FirstCur.vue?vue&type=script&lang=js&"
export * from "./FirstCur.vue?vue&type=script&lang=js&"
import style0 from "./FirstCur.vue?vue&type=style&index=0&id=1be85de3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be85de3",
  null
  
)

export default component.exports